/**
 * compileDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

compileDirective.$inject = ['$compile'];

export function compileDirective($compile) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            scope.$watch(
                function(scope) {
                    // watch the 'compile' expression for changes
                    return scope.$eval(attrs.compile);
                },
                function(value) {
                    // When the 'compile' expression changes assign it into the current DOM
                    element.html(value);

                    // Compile the new DOM and link it to the current scope.
                    // NOTE: we only compile .childNodes so that we don't get into infinite
                    // loop compiling ourselves
                    $compile(element.contents())(scope);
                },
            );
        },
    };
}
